import {configureStore} from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';

import AddressesReducer from './reducers/addresses-reducer';
import AlertReducer from './reducers/alert-reducer';
import AppReducer from './reducers/app-reducer';
import AuthReducer from './reducers/auth-reducer';
import BasketReducer from './reducers/basket-reducer';
import CampaignReducer from './reducers/campaign-reducer';
import RecommendationsReducer from './reducers/recommendations-reducer';
import rootSaga from './sagas';
import {initializeStoreUtil} from './util';

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
  middleware: (defaultMiddleware) => defaultMiddleware().concat(sagaMiddleware),
  reducer: {
    auth: AuthReducer,
    alert: AlertReducer,
    basket: BasketReducer,
    campaign: CampaignReducer,
    addresses: AddressesReducer,
    app: AppReducer,
    recommendations: RecommendationsReducer
  }
});

sagaMiddleware.run(rootSaga);
initializeStoreUtil(store);

export type IRootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
